import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useMemo } from 'react';
import { useDesignContext } from '@klarna/designtokens';
import { isNative } from '@bubble-ui/util-platform';
import defaultDesignTokens from './defaultDesignTokens';

var useTextStyle = function useTextStyle(_ref) {
  var _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'start' : _ref$align,
      _ref$colorToken = _ref.colorToken,
      colorToken = _ref$colorToken === void 0 ? 'colors/text/default' : _ref$colorToken,
      colorTokenArgs = _ref.colorTokenArgs,
      _ref$designTokens = _ref.designTokens,
      designTokens = _ref$designTokens === void 0 ? defaultDesignTokens : _ref$designTokens,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'ltr' : _ref$direction,
      numberOfLines = _ref.numberOfLines,
      _ref$textToken = _ref.textToken,
      textToken = _ref$textToken === void 0 ? 'text-style/text/labels/body/regular' : _ref$textToken,
      textTokenArgs = _ref.textTokenArgs;
  var designContext = useDesignContext(designTokens);
  var color = designContext.get(colorToken, colorTokenArgs).toRGBA();
  var textStyle = designContext.get(textToken, textTokenArgs).styles();
  return useMemo(function () {
    var numberOfLinesStyle = numberOfLines && !isNative ? {
      display: '-webkit-box',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      WebkitBoxOrient: 'vertical',
      WebkitFontSmoothing: 'antialiased',
      WebkitLineClamp: "".concat(numberOfLines)
    } : {}; // use negative margin on native to allow for glyphs exceeding the line-height

    var addRenderingBox = textStyle.lineHeight && isNative;
    var renderingOffset = addRenderingBox ? Math.round(0.2 * textStyle.lineHeight) : 0;
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, addRenderingBox ? {
      marginTop: -renderingOffset,
      marginBottom: -renderingOffset,
      marginLeft: 0,
      marginRight: 0,
      paddingTop: renderingOffset,
      paddingBottom: renderingOffset,
      paddingLeft: 0,
      paddingRight: 0
    } : {
      margin: 0,
      padding: 0
    }), {}, {
      boxSizing: 'border-box',
      flexShrink: 0,
      textRendering: 'geometricPrecision',
      WebkitFontSmoothing: 'antialiased',
      wordBreak: 'break-word',
      textAlign: align === 'start' ? direction === 'rtl' ? 'right' : 'left' : align === 'end' ? direction === 'rtl' ? 'left' : 'right' : align
    }, direction ? isNative ? {
      writingDirection: direction
    } : {
      direction: direction
    } : {}), numberOfLinesStyle), textStyle), {}, {
      color: color
    });
  }, [designContext, align, numberOfLines, color, direction, textStyle]);
};

export default useTextStyle;
//# sourceMappingURL=index.js.map